<template>
  <v-data-table
    :headers="tableHeaders"
    :items="sites"
    item-key="_id"
    class="elevation-1"
    :loading="loadingList"
    loading-text="Данные загружаются... Пожалуйста, подождите."
    :search="search"
    disable-pagination
    hide-default-footer
    sort-by="createdAt"
    :sort-desc="true"
  >
    <template v-slot:top>
      <v-row class="ma-0 pa-0 ml-2 mr-2">
        <v-col cols="10" sm="8">
          <v-text-field
            placeholder="Введите данные для поиска"
            v-model="search"
            class="pr-4"
            clearable
          ></v-text-field>
        </v-col>
        <v-col cols="2" sm="4" class="d-flex pt-5">
          <v-spacer></v-spacer>
          <site-card></site-card>
        </v-col>
      </v-row>
    </template>

    <template v-slot:[`item.createdAt`]="{ item }">
      {{ item.createdAt | localDate }}
    </template>

    <template v-slot:[`item.currentRentDeal`] v-if="isEditor">
      <span>-</span>
    </template>

    <template v-slot:[`item.actions`]="{ item }">
      <site-card :id="item._id"></site-card>

      <delete-button 
        v-if="isAdmin"
        :id="item._id"
        objName="сайт"
        :deleteFunc="$store.dispatch"
        funcParam="sites/delete"
      >
        Название: {{ item.name }}<br>
        URL: {{ item.url }}
      </delete-button>
    </template>

    <template v-slot:footer v-if="isAdmin">
      <div class="pa-5">
        Сумма аренды (в мес): <strong>{{ rentPerMonth }} руб.</strong>
      </div>
      
    </template>
  </v-data-table>
</template>

<script>
import SiteCard from "./SiteCard";
import { mapState, mapGetters } from 'vuex';

export default {
  name: 'sites-list',

  components: {
    SiteCard,
  },

  data() {
    return {
      search: "",
      tableHeaders: [
        {
          text: "Дата создания",
          value: "createdAt"
        },
        {
          text: "Имя",
          value: "name"
        },
        {
          text: "URL",
          value: "url"
        },
        {
          text: "Город",
          value: "city.name"
        },
        {
          text: "Контракт",
          value: "currentRentDeal"
        },
        {
          text: "Действия",
          value: "actions",
          sortable: false
        }
      ]
    };
  },

  async created() {
    this.$store.dispatch('users/loadList');
    //this.$store.dispatch('sites/loadList');
    this.$store.dispatch('prices/loadList');
    this.$store.dispatch('sites/loadCitiesList');
  },
  
  computed: {
    ...mapState('sites', ['sites']),
    ...mapGetters('sites', ['loadingList']),
    ...mapGetters('users', ['isAdmin', 'isEditor']),
    rentPerMonth() {
      return this.sites.reduce((sum, cur) => sum + cur.currentRentDeal, 0);
    }
  }
}
</script>